<template>
  <div class="category-block">
    
    <div class="product-grid">
      <div 
        v-for="(prod, index) in products" 
        :key="prod"
        :class="['product-card', { 'active': prod === currentGarment, 'has-design': hasDesign(prod) }]"
        @click="selectProduct(prod)"
      >
        <div class="product-thumb">
          <img :src="`/images/${iconFiles[index]}`" :alt="prod" style="width:100%; height:100%; object-fit: contain;">
        </div>
        <div class="product-label">{{ prod.toUpperCase() }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useDesignStore } from '@/stores/designStore'
import { onBeforeUnmount } from 'vue'

export default {
  name: 'ProductGrid',
  data() {
    return {
      products: ['Short Sleeve', 'Long Sleeve', 'Cycling Vest', 'Mx Jersey', 'Hoodie', 'T-shirt', 'Baseball Jersey'],
      iconFiles: ['short_sleeve_cycling_jersey.jpg', 'long_sleeve_cycling_jersey.jpg', 'sleeveless_cycling_jersey.jpg', 'mx_cycling_jersey.jpg', 'hoodie.jpg', 't_shirt.jpg', 'baseball_jersey.jpg'],
      currentGarment: 'Short Sleeve'
    }
  },
  mounted() {
    const store = useDesignStore()
    // 初始化时获取当前值
    this.currentGarment = store.currentGarment
    
    // 订阅 store 变化，实时更新 currentGarment
    this._storeUnsubscribe = store.$subscribe((mutation, state) => {
      if (state.currentGarment !== this.currentGarment) {
        this.currentGarment = state.currentGarment
      }
    })
  },
  beforeUnmount() {
    if (this._storeUnsubscribe) {
      this._storeUnsubscribe()
    }
  },
  methods: {
    selectProduct(garmentType) {
      console.log('ProductGrid: selectProduct clicked', garmentType)
      this.$emit('select-garment', garmentType)
    },
    hasDesign(garmentType) {
      const store = useDesignStore()
      const design = store.garmentDesigns[garmentType]
      if (!design) return false
      const hasColors = design.colors && design.colors.size > 0
      const hasTexts = design.texts && design.texts.length > 0
      let hasNonTextLayers = false
      if (design.layers && design.layers.size > 0) {
        for (const layers of design.layers.values()) {
          if (layers && layers.some(l => !l.isText)) {
            hasNonTextLayers = true
            break
          }
        }
      }
      return hasColors || hasTexts || hasNonTextLayers
    }
  }
}
</script>

<style scoped>
.product-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
  justify-content: space-between;
}

.product-card {
  background: #ffffff;
  border-radius: 4px;
  padding: 0.3rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid #2d3748;
}

.product-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.product-card.has-design {
  border: 1px solid #2d3748;
}

.product-card.has-design .product-label {
  color: #ff0000;
  font-weight: bold;
}

.product-card.active {
  border-color: #3b82f6;
  background: #f0f0f0;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
}

.product-thumb {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.product-label {
  font-size: 0.65rem;
  font-weight: 500;
  margin-top: 0.2rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #072a47;
  margin-bottom: 0.3rem;
  padding-left: 4px;
}

.category-block {
  margin-bottom: 0.6rem;
  margin-top: 4px;   /* 给 product-card 的 hover 上移动画留出空间，防止被父容器 overflow 截断 */
  border: none;
  position: relative;
}

@media (max-width: 900px) {
  .product-grid {
    grid-template-columns: repeat(7, 1fr);
    gap: 0.3rem;
  }
  .product-label {
    font-size: 0.55rem;
  }
}

@media (max-width: 850px) {
  .product-card {
    padding-bottom: 0;
  }
  .product-label {
    margin-top: 0.1rem;
    margin-bottom: 0.1rem;
    font-size: 0.55rem;
  }
}
</style>